
ko.bindingHandlers.animVisible = {
    /**
     *  
     * @param {HTMLBaseElement} element
     * @param {any} valueAccessor
     * @param {any} allBindings
     * @param {any} viewModel
     * @param {any} bindingContext
     */
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        element.style.transition = 'opacity 1s ease-in-out';
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        function doAction(val) {
            if (!val) {
                element.style.opacity = 0;

                setTimeout(() => {
                    element.style.display = 'none';
                }, 1000)
            } else {
                element.style.display = 'block';
                element.style.opacity = 1;
            }
        }

        doAction(ko.unwrap(valueAccessor()));
    }
};